import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '@coin/shared/core/util-environments';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserMenuState } from '../header/components/user-menu/state/user-menu.state';
import { Employee } from '../../api/generated';

@Component({
  selector: 'cosmos-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SidebarComponent {
  private eRef = inject(ElementRef);
  private events = inject(GlobalEventsService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private store = inject(Store);

  public isSidebarVisible = false;
  public titles: string[] = ['Apps'];
  public selectedMenuItem: string = this.titles[0];
  public environment = environment;
  public userDetails$: Observable<Employee> = this.store.select(UserMenuState.userDetails);
  public sideBarCollapsed$ = new BehaviorSubject<boolean>(!this.isSidebarVisible);

  clickout = (event: MouseEvent): void => {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.isSidebarVisible) {
        this.onSidebarToggle();
        this.cdr.detectChanges();
      }
    }
  };

  constructor() {
    this.events
      .listen('click')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(e => this.clickout(e));
  }

  public onSidebarToggle(title?: string): void {
    if (title) {
      this.selectedMenuItem = title;
    }

    this.isSidebarVisible = !this.isSidebarVisible;
    this.sideBarCollapsed$.next(!this.isSidebarVisible);
  }

  public toggleMenuItem(menuItem: string): void {
    if (this.selectedMenuItem === menuItem) {
      this.selectedMenuItem = '';
    } else {
      this.selectedMenuItem = menuItem;
    }
  }
}
